import sites from './sites';

export default {
  sites,
};
